module.exports = __webpack_public_path__ + "img/volume.a8b90d8b.svg";